import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";

// action types

export const VALIDATION_VARIATION = "validationVariation";
export const ADD_VARIATION = "addVariation";
export const UPDATE_VARIATION = "updateVariation";
export const DELETE_VARIATION = "deleteVariation";

// mutation types
export const SET_NEW_VARIATION = "setNewVariation";
export const SET_VARIATIONS_ERROR = "setErrorsVariation";
export const SET_VARIATION_LOAD = "setVariationLoad";

const state = {
    errors: {},
    new_variation: {},
    load: true,
};

const getters = {

    gettersNewVariation(state) {
        return state.new_variation;
    },
    errorsVariation(){
        return state.errors;
    },
    getVariationLoad(){
        return state.load;
    },
};

const actions = {

    [ADD_VARIATION](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_VARIATIONS_ERROR, {});
            ApiService.store("/variation/store", data.product, data.variation)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_NEW_VARIATION, data.variation);

                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_VARIATIONS_ERROR, response.data.errors);
                    }
                });
        });
    },


    [VALIDATION_VARIATION](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_VARIATIONS_ERROR, {});
            ApiService.post("/variation/validation", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_VARIATIONS_ERROR, response.data.errors);
                    }
                });
        });
    },


    [UPDATE_VARIATION](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/variation/update", data.id, data.variation)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_VARIATIONS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_VARIATIONS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [DELETE_VARIATION](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/variation/delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_VARIATIONS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    }

}


const mutations = {

    [SET_NEW_VARIATION](state, variation) {
        state.new_variation = variation;
    },

    [SET_VARIATIONS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_VARIATION_LOAD](state, load) {
        state.load = load;
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};

